__turbopack_context__.v({
  "large": "TeaserHeading-module-scss-module__xfrXea__large",
  "premium": "TeaserHeading-module-scss-module__xfrXea__premium",
  "teaserTitle": "TeaserHeading-module-scss-module__xfrXea__teaserTitle",
  "titleVignette": "TeaserHeading-module-scss-module__xfrXea__titleVignette",
});
